import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import Button from '../Button';
import Modal from '../Modal';

export default function LogoutModal({
  isShowLogoutModal,
  activePackage,
  notificationId,
  updateViewStatusNotification,
}) {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (isShowLogoutModal) {
      setOpen(true);
    }
  }, [isShowLogoutModal]);

  const handleCloseModal = async () => {
    await updateViewStatusNotification(notificationId);
    setOpen(false);
    document.location.href = '/logout-login';
  };

  const getFooter = () => {
    return (
      <>
        <Button onClick={handleCloseModal}>Đăng nhập</Button>
      </>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onCloseModal={handleCloseModal}
      contentClassName="max-w-[96%] md:max-w-md m-auto w-full"
      title={`Gói ${activePackage?.packageName} đã được kích hoạt`}
      mainContentClassName="modal-center sm:max-w-[480px]"
      footerContent={getFooter()}
      hideCloseButton
      childrenClassName="mt-0 py-3"
    >
      <p className="text-sm text-gray-700 dark:text-gray-400">
        Gói <strong>{activePackage?.packageName}</strong> đã được kích hoạt
        thành công và hết hạn vào ngày{' '}
        <strong>
          {activePackage?.expiredDate
            ? dayjs(activePackage?.expiredDate).format('DD/MM/YYYY')
            : ''}
        </strong>
        . Cám ơn bạn đã sử dụng dịch vụ của <strong>Stockup.vn</strong>. Vui
        lòng đăng nhập lại để sử dụng.
      </p>
    </Modal>
  );
}
